<template>
  <div class="auth-page">
    <div class="auth-card">
      <div class="brand">
        <img src="/assets/images/paysol_logo.png" alt="Paysol" />
        <div class="lang-wrap"><LanguageToggle /></div>
      </div>

      <div class="tab-row">
        <button :class="{tab:true, active: mode==='password'}" @click="mode='password'">{{ t('login.tabPassword') }}</button>
        <button :class="{tab:true, active: mode==='pin'}" @click="mode='pin'">{{ t('login.tabPin') }}</button>
      </div>

      <form @submit.prevent="submit" v-if="mode === 'password'">
        <label>{{ t('common.email') }}</label>
        <input v-model="form.email" type="email" autocomplete="username" required />
        <label>{{ t('common.password') }}</label>
        <input v-model="form.password" type="password" autocomplete="current-password" required />
        <button type="submit" class="primary full" :disabled="loading">
          {{ loading ? t('login.signingIn') : t('common.signIn') }}
        </button>
      </form>

      <form @submit.prevent="submitPin" v-if="mode === 'pin'">
        <label>{{ t('login.businessId') }}</label>
        <input v-model.number="pinForm.tenantId" type="number" placeholder="e.g. 1" required />
        <label>{{ t('login.pin') }}</label>
        <input v-model="pinForm.pin" type="password" inputmode="numeric" maxlength="6" required />
        <button type="submit" class="primary full" :disabled="loading">
          {{ loading ? t('login.signingIn') : t('login.signInToTill') }}
        </button>
      </form>

      <p class="err" v-if="error">{{ error }}</p>

      <div class="foot">
        <router-link to="/register">{{ t('login.createNew') }}</router-link>
        <router-link to="/">&larr; {{ t('login.home') }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { paysol, saveAuth } from '@/api';
import { t } from '@/i18n';
import LanguageToggle from '@/i18n/LanguageToggle.vue';

export default {
  name: 'Login',
  components: { LanguageToggle },
  data() {
    return {
      localeTick: 0,
      mode: 'password',
      form: { email: '', password: '' },
      pinForm: { tenantId: null, pin: '' },
      loading: false,
      error: ''
    };
  },
  mounted() {
    this._onLoc = () => { this.localeTick++; };
    window.addEventListener('paysol-locale-changed', this._onLoc);
  },
  beforeUnmount() {
    if (this._onLoc) window.removeEventListener('paysol-locale-changed', this._onLoc);
  },
  methods: {
    t(key, vars) { this.localeTick; return t(key, vars); },
    async submit() {
      this.error = ''; this.loading = true;
      try {
        const { data } = await axios.post(paysol, { function: 'login', ...this.form });
        if (!data.success) { this.error = data.message; return; }
        saveAuth(data.data);
        this.$router.push('/dashboard');
      } catch (e) {
        this.error = e.response?.data?.message || this.t('login.wrongPassword');
      } finally { this.loading = false; }
    },
    async submitPin() {
      this.error = ''; this.loading = true;
      try {
        const { data } = await axios.post(paysol, { function: 'loginPin', ...this.pinForm });
        if (!data.success) { this.error = data.message; return; }
        saveAuth(data.data);
        this.$router.push('/pos');
      } catch (e) {
        this.error = e.response?.data?.message || 'PIN sign-in failed.';
      } finally { this.loading = false; }
    }
  }
};
</script>

<style scoped>
.auth-page { min-height: 100vh; display: flex; align-items: center; justify-content: center; padding: 24px; }
.auth-card { width: 100%; max-width: 400px; background: var(--paysol-card); border: 1px solid var(--paysol-line); border-radius: 10px; padding: 28px; }
.brand { text-align: center; margin-bottom: 20px; position: relative; }
.brand img { height: 60px; filter: brightness(1.1); }
.lang-wrap { position: absolute; top: 0; right: 0; }
.tab-row { display: flex; gap: 4px; background: var(--paysol-bg-elev); padding: 4px; border-radius: 8px; margin-bottom: 20px; }
button.tab { flex: 1; background: transparent; color: var(--paysol-muted); padding: 8px 12px; font-size: 12px; border-radius: 5px; }
button.tab.active { background: var(--paysol-teal); color: #fff; }
form label { margin-top: 12px; }
button.full { width: 100%; margin-top: 20px; padding: 12px; }
.err { color: var(--paysol-danger); font-size: 13px; margin-top: 12px; text-align: center; }
.foot { display: flex; justify-content: space-between; margin-top: 20px; font-size: 12px; }
</style>
